// extracted by mini-css-extract-plugin
module.exports = {"part2":"part2_part2__1IGHP","top":"part2_top__28u1w","inner":"part2_inner__35-Nh","item":"part2_item__3kcI3"};